import { differenceInYears, differenceInMonths } from "date-fns";
import { ONE_DAY } from "config/common";
import { TFunction } from "i18n";

import { IPhoto } from "models/api";
import { IMakeSuggestionsPerformer, MembershipTypes } from "models/suggestion";

export function getExpirationDate(
  contractExpirationWarning: string,
  expiryDate?: string
) {
  if (expiryDate) {
    const today = new Date().getTime();
    const expiry = new Date(expiryDate).getTime();
    const days = Math.ceil((expiry - today) / ONE_DAY);

    return contractExpirationWarning.replace("{0}", days.toString());
  }

  return undefined;
}

export function getFormattedYoungPerformerAge(
  t: TFunction,
  dateOfBirth?: string
) {
  if (dateOfBirth) {
    const now = new Date();
    const dobDate = new Date(dateOfBirth);
    const ageYears = differenceInYears(now, dobDate);
    const currentYearInMonths =
      differenceInMonths(now, dobDate) - ageYears * 12;

    return t("common:suggestions.youngPerformer.card.age", {
      years: ageYears,
      months: currentYearInMonths,
    });
  }
}

export function getMembershipType(
  type: string,
  texts: {
    performer: string;
    graduate: string;
    youngPerformer: string;
    presenter: string;
    dancer: string;
  }
) {
  const translationMapping = {
    [MembershipTypes.performer]: texts.performer,
    [MembershipTypes.presenter]: texts.presenter,
    [MembershipTypes.youngPerformer]: texts.youngPerformer,
    [MembershipTypes.graduate]: texts.graduate,
    [MembershipTypes.dancer]: texts.dancer,
  };

  return translationMapping[type];
}

export const getPhotos = (performer: IMakeSuggestionsPerformer): IPhoto[] => {
  return [performer.mainPhoto, ...performer.gallery];
};

export const findPhoto = (performer: IMakeSuggestionsPerformer): IPhoto => {
  return (
    performer.gallery.find(
      (photo) => photo.id === performer.suggestion?.photo
    ) || performer.mainPhoto
  );
};
